import { CloseRounded, NavigateBeforeRounded, NavigateNextRounded } from "@mui/icons-material";
import { Box, Button, Dialog, Divider, IconButton, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useRef, useState } from "react";
import EditDetailsContent from "./EditDetailsContent/EditDetailsContent";

const EditDetailsModal = ({
	modal,
	setModal,
	selectedStyle,
	setSelectedStyle,
	saveCallback,
	currentIndex = 0,
	totalCount = 0,
	onPrev = () => {},
	onNext = () => {},
}) => {
	const [busy, setBusy] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const headerActionsRef = useRef({ publish: () => {} });

	useEffect(() => {
		if (modal) setIsEditMode(false);
	}, [modal, selectedStyle?.style_id]);

	const handleModalClose = () => {
		setModal(false);
		setSelectedStyle();
	};

	const handleCancelEdit = () => {
		setIsEditMode(false);
	};

	const handleEnterEdit = () => {
		setIsEditMode(true);
	};

	return (
		<Dialog fullWidth maxWidth="xl" open={modal} onClose={handleModalClose} scroll="paper" PaperProps={{ sx: { height: "92vh" } }}>
			<Box sx={{ height: "100%", p: 2, overflow: "hidden" }}>
				<Box display="flex" justifyContent="space-between" alignItems="center" gap={1} flexWrap="wrap">
					<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
						<Typography variant="h6">Edit Buy Qty</Typography>
						<Typography variant="body2" color={grey[600]}>
							{totalCount ? currentIndex + 1 : 0} / {totalCount}
						</Typography>
					</Box>
					<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
						<Button
							variant="contained"
							color="success"
							onClick={() => headerActionsRef.current?.publish?.()}
							disabled={busy || isEditMode || currentIndex <= 0 || currentIndex >= totalCount - 1}>
							Publish
						</Button>
						<Button
							variant="outlined"
							startIcon={<NavigateBeforeRounded />}
							onClick={onPrev}
							disabled={busy || isEditMode || currentIndex <= 0}>
							Prev
						</Button>
						<Button
							variant="outlined"
							endIcon={<NavigateNextRounded />}
							onClick={onNext}
							disabled={busy || isEditMode || currentIndex >= totalCount - 1}>
							Next
						</Button>
						<IconButton aria-label="close" onClick={handleModalClose} disabled={busy}>
							<CloseRounded />
						</IconButton>
					</Box>
				</Box>

				<EditDetailsContent
					modal={modal}
					selectedStyle={selectedStyle}
					saveCallback={saveCallback}
					onClose={handleModalClose}
					onCancelEdit={handleCancelEdit}
					onExitEdit={handleCancelEdit}
					onEnterEdit={handleEnterEdit}
					onBusyChange={setBusy}
					isEditMode={isEditMode}
					onRegisterActions={(actions) => {
						headerActionsRef.current = actions ?? { publish: () => {} };
					}}
				/>
			</Box>
		</Dialog>
	);
};

export default EditDetailsModal;
